import styled from "styled-components";

export const BottomNav = styled.nav`
  grid-area: BN;
  width: 100vw;
  padding: 0 8px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: ${(props) => props.theme.shadow.navigation};
  -webkit-box-shadow: ${(props) => props.theme.shadow.navigation};
  -moz-box-shadow: ${(props) => props.theme.shadow.navigation};
`;

export const BottomNavList = styled.ul`
  display: grid;
  width: 100%;
  height: 70px;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  justify-content: center;
  gap: 6px;
`;
